import axios from "axios";
import { serviceUrl } from "../../config";

const BACKEND_URL = serviceUrl;

export const checkLoanEligibility = async (
  location,
  userid,
  currcode,
  sampleloantype,
  sampleloanamount,
  sampleloanamountforfeecalculation,
  sampletermtype,
  refid,
  returnoutstandingloans,
  intent
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "getLoansInfo",
      dat: {
        location,
        userid,
        currcode,
        sampleloantype,
        sampleloanamount,
        sampleloanamountforfeecalculation,
        sampletermtype,
        refid,
        returnoutstandingloans,
        intent,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const addLoanLimit = async (
  location,
  userid,
  currcode,
  eligiblelimit,
  status
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "addLoanLimit",
      dat: {
        location,
        userid,
        currcode,
        eligiblelimit,
        status,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loanOptIn = async (
  location,
  userid,
  currcode,
  refid,
  externaluserid
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "loanOptIn",
      dat: {
        location,
        userid,
        currcode,
        refid,
        externaluserid,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loanRequest = async (
  location,
  userid,
  currcode,
  loantype,
  amount,
  amountforfeecalculation,
  refno,
  checkuniquerefno,
  paymenttargetdate,
  checkblockacrossmultiplecurrency,
  externaluserid,
  otherdetails,
  termtype,
  storeloanrequest
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "loanRequest",
      dat: {
        location,
        userid,
        currcode,
        loantype,
        amount,
        amountforfeecalculation,
        refno,
        checkuniquerefno,
        paymenttargetdate,
        checkblockacrossmultiplecurrency,
        externaluserid,
        otherdetails,
        termtype,
        storeloanrequest,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loanDisbursementConfirmation = async (
  location,
  userid,
  loanid
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoanDisbursementConfirmation",
      dat: {
        location,
        userid,
        loanid
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loanRequestOnly = async (
  location,
  userid,
  currcode,
  loantype,
  amount,
  amountforfeecalculation,
  refno,
  checkuniquerefno
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "loanRequestOnly",
      dat: {
        location,
        userid,
        currcode,
        loantype,
        amount,
        amountforfeecalculation,
        refno,
        checkuniquerefno
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loanRequestOnlyDynamic = async (
  location,
  userid,
  currcode,
  loantype,
  amount,
  amountforfeecalculation,
  refno,
  checkuniquerefno,
  issued
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "loanRequestOnlyDynamic",
      dat: {
        location,
        userid,
        currcode,
        loantype,
        amount,
        amountforfeecalculation,
        refno,
        checkuniquerefno,
        issued
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const listAllUserLoanProducts = async (queryid, userid) => {
  try {
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "RunQuery2",
      dat: {
        queryid: queryid,
        param: userid,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const listLoanSubProducts = async (queryid, productid) => {
  try {
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "RunQuery2",
      dat: {
        queryid: queryid,
        param: productid,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const listProductsAssignedToUsers = async (queryid, userId) => {
  try {
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "RunQuery2",
      dat: {
          queryid: queryid,
          param: userId,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loanOptOut = async (
  location,
  userid,
  currcode,
  refid
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "loanOptOut",
      dat: {
        location,
        userid,
        currcode,
        refid
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getSingleProductDetails = async (queryid, productId) => {
  try {
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "RunQuery2",
      dat: {
          queryid: queryid,
          param: productId,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getListOfLoansToApprove = async (queryid, userid) => {
  try {
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "RunQuery2",
      dat: {
        queryid: queryid,
        param: userid,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loanApprove = async (
  location,
  loanrequestid,
  status,
  approvedby,
  comment
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "loanApprove",
      dat: {
        location,
        loanrequestid,
        status,
        approvedby,
        comment
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loanCancel = async (
  location,
  userid,
  loanid,
  refid,
  reason,
  loanrefno
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "loanCancel",
      dat: {
        location,
        userid,
        loanid,
        refid,
        reason,
        loanrefno
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loanLimitEdit = async (
  location,
  userid,
  currcode,
  eligiblelimit,
  status
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "loanLimitEdit",
      dat: {
        location,
        userid,
        currcode,
        eligiblelimit,
        status
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loanPayment = async (
  location,
  userid,
  currcode,
  amount,
  refno,
  checkuniquerefno,
  loanid,
  latefeesonly,
  externaluserid,
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "loanPayment",
      dat: {
        location,
        userid,
        currcode,
        amount,
        refno,
        checkuniquerefno,
        loanid,
        latefeesonly,
        externaluserid,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loanPaymentInfo = async (
  location,
  userid,
  refno,
  currcode
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "loanPaymentInfo",
      dat: {
        location,
        userid,
        refno,
        currcode
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loanPaymentCancel = async (
  location,
  userid,
  paymentid,
  paymentrefno,
  confirmationrefno,
  reason,
  loanid,
  currcode,
  originalrequestid
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "loanPaymentCancel",
      dat: {
        location,
        userid,
        paymentid,
        paymentrefno,
        confirmationrefno,
        reason,
        loanid,
        currcode,
        originalrequestid
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getListOfUserPayments = async (queryid, userid) => {
  try {
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "RunQuery2",
      dat: {
        queryid: queryid,
        param: userid,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const commonRunQuery = async (queryid, params) => {
  try {
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "RunQuery2",
      dat: {
        queryid: queryid,
        param: params,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loanPaymentPlanRetrieve = async (
  location,
  userid,
  loanid
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoanPaymentPlanRetrieve",
      dat: {
        location,
        userid,
        loanid
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const GetUserExternalRef = async (userid, exttype) => {
  try {
    const data = JSON.stringify({
      svc: "crm_users",      // now correctly routed to crm_users class
      pid: "GetUserExternalRef",
      dat: {
        location: "",
        userid: userid,
        exttype: exttype,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: { "Content-Type": "application/json" },
      data: data,
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loanPaymentPlanCreate = async (
  location,
  loanid,
  loanamount,
  interestamount,
  termpaymentamount,
  noofterms,
  termtype,
  firstpaymentduedate,
  depositamount
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoanPaymentPlanCreate",
      dat: {
        location,
        loanid,
        loanamount,
        interestamount,
        termpaymentamount,
        noofterms,
        termtype,
        firstpaymentduedate,
        depositamount
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const listCurrencies = async (
  langid
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "ListCurrencies",
      dat: {
        langid
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loansCreateCategory = async (
  category
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoansCreateCategory",
      dat: {
        category
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loansUpdateCategory = async (
  categoryid,
  category
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoansUpdateCategory",
      dat: {
        categoryid,
        category
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loansCreateProduct = async (
  productid,
  name,
  categoryid,
  currencycode,
  autoapprove,
  minlimit = "0.00",      // ← NEW (default to 0 if not provided)
  maxlimit = "0.00"       // ← NEW
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoansCreateProduct",
      dat: {
        productid,
        name,
        categoryid,
        currencycode,
        autoapprove,
        minlimit,             
        maxlimit              
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loansUpdateProduct = async (
  productid,
  name,
  categoryid,
  currencycode,
  autoapprove,
  minlimit = "0.00",      
  maxlimit = "0.00"       
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoansUpdateProduct",
      dat: {
        productid,
        name,
        categoryid,
        currencycode,
        autoapprove,
        minlimit,             
        maxlimit              
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loansCreateLoanType = async (
  location,
  timegranularity,
  terminterestallocationtype,
  stopcalculatingafterdays,
  selectablebyuser,
  restrictive,
  purchasetableid,
  productid,
  optout,
  optin,
  numberofdays,
  noofduedays,
  nextloantype,
  maxactiveloans,
  loandesc,
  latefeetableid,
  isflaggedloandue,
  includefeesineligibilitycheck,
  ignorenextbusinessday,
  ignoreholidays,
  graceperioddays,
  flaggingwaringdays,
  flaggingdays,
  flagging,
  feetax,
  feeperc,
  feefixed,
  feecalculationmode,
  displayorderno,
  disbursementtype,
  unblocklangid,
  optoutlangid,
  optinlangid,
  noteligiblelangid,
  nexttierwarninglangid,
  nexttiernotificationlangid,
  loanrequestwarninglangid,
  loanrequestconfirmationlangid,
  loanpaymentconfirmationlangid,
  loanlimitlangid,
  latefeewarninglangid,
  latefeelangid,
  flagwarninglangid,
  flaggedlangid,
  blockedlangid,
  paymentterms // newly added
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoansCreateLoanType",
      dat: {
        location,
        timegranularity,
        terminterestallocationtype,
        stopcalculatingafterdays,
        selectablebyuser,
        restrictive,
        purchasetableid,
        productid,
        optout,
        optin,
        numberofdays,
        noofduedays,
        nextloantype,
        maxactiveloans,
        loandesc,
        latefeetableid,
        isflaggedloandue,
        includefeesineligibilitycheck,
        ignorenextbusinessday,
        ignoreholidays,
        graceperioddays,
        flaggingwaringdays,
        flaggingdays,
        flagging,
        feetax,
        feeperc,
        feefixed,
        feecalculationmode,
        displayorderno,
        disbursementtype,
        unblocklangid,
        optoutlangid,
        optinlangid,
        noteligiblelangid,
        nexttierwarninglangid,
        nexttiernotificationlangid,
        loanrequestwarninglangid,
        loanrequestconfirmationlangid,
        loanpaymentconfirmationlangid,
        loanlimitlangid,
        latefeewarninglangid,
        latefeelangid,
        flagwarninglangid,
        flaggedlangid,
        blockedlangid,
        paymentterms // newly added
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loansUpdateLoanType = async (
  location,
  loantype,
  timegranularity,
  terminterestallocationtype,
  stopcalculatingafterdays,
  selectablebyuser,
  restrictive,
  purchasetableid,
  productid,
  optout,
  optin,
  numberofdays,
  noofduedays,
  nextloantype,
  maxactiveloans,
  loandesc,
  latefeetableid,
  isflaggedloandue,
  includefeesineligibilitycheck,
  ignorenextbusinessday,
  ignoreholidays,
  graceperioddays,
  flaggingwaringdays,
  flaggingdays,
  flagging,
  feetax,
  feeperc,
  feefixed,
  feecalculationmode,
  displayorderno,
  disbursementtype,
  unblocklangid,
  optoutlangid,
  optinlangid,
  noteligiblelangid,
  nexttierwarninglangid,
  nexttiernotificationlangid,
  loanrequestwarninglangid,
  loanrequestconfirmationlangid,
  loanpaymentconfirmationlangid,
  loanlimitlangid,
  latefeewarninglangid,
  latefeelangid,
  flagwarninglangid,
  flaggedlangid,
  blockedlangid,
  paymentterms // newly added
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoansUpdateLoanType",
      dat: {
        location,
        loantype,
        timegranularity,
        terminterestallocationtype,
        stopcalculatingafterdays,
        selectablebyuser,
        restrictive,
        purchasetableid,
        productid,
        optout,
        optin,
        numberofdays,
        noofduedays,
        nextloantype,
        maxactiveloans,
        loandesc,
        latefeetableid,
        isflaggedloandue,
        includefeesineligibilitycheck,
        ignorenextbusinessday,
        ignoreholidays,
        graceperioddays,
        flaggingwaringdays,
        flaggingdays,
        flagging,
        feetax,
        feeperc,
        feefixed,
        feecalculationmode,
        displayorderno,
        disbursementtype,
        unblocklangid,
        optoutlangid,
        optinlangid,
        noteligiblelangid,
        nexttierwarninglangid,
        nexttiernotificationlangid,
        loanrequestwarninglangid,
        loanrequestconfirmationlangid,
        loanpaymentconfirmationlangid,
        loanlimitlangid,
        latefeewarninglangid,
        latefeelangid,
        flagwarninglangid,
        flaggedlangid,
        blockedlangid,
        paymentterms // newly added
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loansUpdateLoanTypeLangIds = async (
  location,
  loantype,
  unblocklangid,
  optoutlangid,
  optinlangid,
  noteligiblelangid,
  nexttierwarninglangid,
  nexttiernotificationlangid,
  loanrequestwarninglangid,
  loanrequestconfirmationlangid,
  loanpaymentconfirmationlangid,
  loanlimitlangid,
  latefeewarninglangid,
  latefeelangid,
  flagwarninglangid,
  flaggedlangid,
  blockedlangid
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoansUpdateLoanTypeLangIds",
      dat: {
        location,
        loantype,
        unblocklangid,
        optoutlangid,
        optinlangid,
        noteligiblelangid,
        nexttierwarninglangid,
        nexttiernotificationlangid,
        loanrequestwarninglangid,
        loanrequestconfirmationlangid,
        loanpaymentconfirmationlangid,
        loanlimitlangid,
        latefeewarninglangid,
        latefeelangid,
        flagwarninglangid,
        flaggedlangid,
        blockedlangid
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loansDeleteCategory = async (
  location,
  categoryid
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoansDeleteCategory",
      dat: {
        location,
        categoryid
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loansDeleteProduct = async (
  location,
  productid
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoansDeleteProduct",
      dat: {
        location,
        productid
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loansCreateLanguageTag = async (
  location,
  langID,
  tagID,
  label
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoansCreateLanguageTag",
      dat: {
        location,
        langID,
        tagID,
        label
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const DeleteUserExternalRef = async (refid) => {
  try {
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "DeleteUserExternalRef",
      dat: {
        location: "",
        refid: refid,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: { "Content-Type": "application/json" },
      data: data,
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loansUpdateLangTag = async (
  location,
  tagID,
  langID,
  label
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoansUpdateLangTag",
      dat: {
        location,
        langID,
        tagID,
        label
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const retrieveExtCode = async (
  exttype,
  referralcode,
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "RetrieveExtCode",
      dat: {
        exttype,
        referralcode
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const registerExtID2 = async (
  location,
  exttype,
  extuserkey,
  userid,
  initialstatus,
  userpi
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "RegisterExtID2",
      dat: {
        location,
        exttype,
        extuserkey,
        userid,
        initialstatus,
        userpi
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loansCreateLanguage = async (
  location,
  langid
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoansCreateLanguage",
      dat: {
        location,
        langid
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loansUpdateLanguage = async (
  location,
  langid,
  langTagId
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoansUpdateLanguage",
      dat: {
        location,
        langid,
        langTagId
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loansCreateCurrMessage = async (
  location,
  loancurr,
  stopoptoutonoutstandingbalance,
  paymentconfirmedinitialstat,
  realtimescorestatus,
  realtimescoremodule,
  realtimescoregatewayid,
  loanissuedreconciliationmodule,
  loanpaymentreconciliationmodule,
  countrycode,
  loanoptinmodule,
  latefeecalculationmode,
  notificationlastday,
  isdefaultoptin,
  loanoptoutmodule,
  loannotificationmodule,
  balancecheck,
  loanpaymentreconciliationmodule2,
  loanissuedreconciliationmodule2,
  flagmessagelangid,
  blockmessagelangid,
  loanrepaymentlangid
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoansCreateCurrMessage",
      dat: {
        location,
        loancurr,
        stopoptoutonoutstandingbalance,
        paymentconfirmedinitialstat,
        realtimescorestatus,
        realtimescoremodule,
        realtimescoregatewayid,
        loanissuedreconciliationmodule,
        loanpaymentreconciliationmodule,
        countrycode,
        loanoptinmodule,
        latefeecalculationmode,
        notificationlastday,
        isdefaultoptin,
        loanoptoutmodule,
        loannotificationmodule,
        balancecheck,
        loanpaymentreconciliationmodule2,
        loanissuedreconciliationmodule2,
        flagmessagelangid,
        blockmessagelangid,
        loanrepaymentlangid
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loansUpdateCurrMessage = async (
  location,
  loancurr,
  stopoptoutonoutstandingbalance,
  paymentconfirmedinitialstat,
  realtimescorestatus,
  realtimescoremodule,
  realtimescoregatewayid,
  loanissuedreconciliationmodule,
  loanpaymentreconciliationmodule,
  countrycode,
  loanoptinmodule,
  latefeecalculationmode,
  notificationlastday,
  isdefaultoptin,
  loanoptoutmodule,
  loannotificationmodule,
  balancecheck,
  loanpaymentreconciliationmodule2,
  loanissuedreconciliationmodule2,
  flagmessagelangid,
  blockmessagelangid,
  loanrepaymentlangid
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoansUpdateCurrMessage",
      dat: {
        location,
        loancurr,
        stopoptoutonoutstandingbalance,
        paymentconfirmedinitialstat,
        realtimescorestatus,
        realtimescoremodule,
        realtimescoregatewayid,
        loanissuedreconciliationmodule,
        loanpaymentreconciliationmodule,
        countrycode,
        loanoptinmodule,
        latefeecalculationmode,
        notificationlastday,
        isdefaultoptin,
        loanoptoutmodule,
        loannotificationmodule,
        balancecheck,
        loanpaymentreconciliationmodule2,
        loanissuedreconciliationmodule2,
        flagmessagelangid,
        blockmessagelangid,
        loanrepaymentlangid
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loansCreateBankCode = async (
  location,
  bankcode,
  bankname
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoansCreateBankCode",
      dat: {
        location,
        bankcode,
        bankname
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loansUpdateBankCode = async (
  location,
  id,
  bankcode,
  bankname
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoansUpdateBankCode",
      dat: {
        location,
        id,
        bankcode,
        bankname
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const postAdjustmentNoPin10 = async (
  location,
  fromuserid,
  touserid,
  currency,
  transactions,
  reason,
  externalrefid,
  sourcepi,
  targetpi,
  sourceuserpi,
  targetuserpi,
  clerkname,
  transtypeid,
  recipientaccountno,
  adminmsg,
  channelid,
  recipientuserid,
  parentuserid
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "PostAdjustmentNoPin10",
      dat: {
        location,
        fromuserid,
        touserid,
        currency,
        transactions,
        reason,
        externalrefid,
        sourcepi,
        targetpi,
        sourceuserpi,
        targetuserpi,
        clerkname,
        transtypeid,
        recipientaccountno,
        adminmsg,
        channelid,
        recipientuserid,
        parentuserid
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loanPaymentConfirmation7 = async (
  location,
  userid,
  paymentid,
  paymentrefno,
  confirmationrefno,
  loanid,
  currcode
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoanPaymentConfirmation7",
      dat: {
        location,
        userid,
        paymentid,
        paymentrefno,
        confirmationrefno,
        loanid,
        currcode
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const loanRequestCancel = async (
  location,
  requestid
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoanRequestCancel",
      dat: {
        location,
        requestid
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const listTransactionHistory5 = async (
  location,
  accountid,
  currencycode,
  languagecode,
  timezone,
  sortorder,
  startdate,
  enddate
) => {
  try {
    const data = JSON.stringify({
      svc: "grouploans",
      pid: "ListTransactionHistory5",
      dat: {
        location,
        accountid,
        currencycode,
        languagecode,
        timezone,
        sortorder,
        startdate,
        enddate
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const purchaseFeeTableList = async (location = "", includeactiveonly = 0) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "PurchaseFeeTableList",
      dat: {
        location,
        includeactiveonly: includeactiveonly ? 1 : 0,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log("PurchaseFeeTableList Response:", response.data);

    return response.data;
  } catch (error) {
    console.error("PurchaseFeeTableList API Error:", error);
    throw error; // Let caller handle it
  }
};

export const purchaseFeeTableAdd = async (feeData) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "PurchaseFeeTableAdd",
      dat: feeData,
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log("PurchaseFeeTableAdd Response:", response.data);

    return response.data;
  } catch (error) {
    console.error("PurchaseFeeTableAdd API Error:", error);
    throw error;
  }
};

export const purchaseFeeTableEdit = async (feeData) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "PurchaseFeeTableEdit",
      dat: feeData,
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log("PurchaseFeeTableEdit Response:", response.data);

    return response.data;
  } catch (error) {
    console.error("PurchaseFeeTableEdit API Error:", error);
    throw error;
  }
};

export const purchaseFeeList = async (location = "", tableid = "") => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "PurchaseFeeList",
      dat: {
        location,
        tableid,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log("PurchaseFeeList Response:", response.data);

    return response.data;
  } catch (error) {
    console.error("PurchaseFeeList API Error:", error);
    throw error;
  }
};


   export const purchaseFeeAdd = async (feeData) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "PurchaseFeeAdd",
      dat: feeData,
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log("PurchaseFeeAdd Response:", response.data);

    return response.data;
  } catch (error) {
    console.error("PurchaseFeeAdd API Error:", error);
    throw error;
  }
};
 
export const purchaseFeeEdit = async (feeData) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "PurchaseFeeEdit",
      dat: feeData,
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log("PurchaseFeeEdit Response:", response.data);

    return response.data;
  } catch (error) {
    console.error("PurchaseFeeEdit API Error:", error);
    throw error;
  }
};

export const userScoreAdd = async (scoreData) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "UserScoreAdd",
      dat: scoreData, // expects: { location, userid, scoresourceid, score, meta }
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log("UserScoreAdd Response:", response.data);

    return response.data;
  } catch (error) {
    console.error("UserScoreAdd API Error:", error);
    throw error; 
  }
};

export const userScoreEdit = async (scoreData) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "UserScoreEdit",
      dat: scoreData, // expects: { location, userid, scoresourceid, score, meta }
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log("UserScoreEdit Response:", response.data);

    return response.data;
  } catch (error) {
    console.error("UserScoreEdit API Error:", error);
    throw error;
  }
};

export const loanLimitRulesAdd = async (ruleData) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoanLimitRulesAdd",
      dat: {
        location: ruleData.location ?? "",
        name: ruleData.name ?? "",
        is_active: ruleData.is_active ?? 1,
        priority: ruleData.priority ?? 100,
        match_logic: ruleData.match_logic ?? "ALL",
        min_factors: ruleData.min_factors ?? null,
        severity: ruleData.severity ?? "INFO",
        valid_from: ruleData.valid_from ?? null,
        valid_to: ruleData.valid_to ?? null,
        version: ruleData.version ?? 1,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log("LoanLimitRulesAdd Response:", response.data);

    return response.data;
  } catch (error) {
    console.error("LoanLimitRulesAdd API Error:", error);
    throw error;
  }
};

export const loanLimitRulesEdit = async (ruleData) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoanLimitRulesEdit",
      dat: {
        location: ruleData.location ?? "",
        id: ruleData.id, // Required — no default
        name: ruleData.name ?? "",
        is_active: ruleData.is_active ?? 1,
        priority: ruleData.priority ?? 100,
        match_logic: ruleData.match_logic ?? "ALL",
        min_factors: ruleData.min_factors ?? null,
        severity: ruleData.severity ?? "INFO",
        valid_from: ruleData.valid_from ?? null,
        valid_to: ruleData.valid_to ?? null,
        version: ruleData.version, // Required for concurrency — no default
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log("LoanLimitRulesEdit Response:", response.data);

    return response.data;
  } catch (error) {
    console.error("LoanLimitRulesEdit API Error:", error);
    throw error;
  }
};

// Add a new condition
export const addRuleCondition = async (conditionData) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoanLimitRuleConditionsAdd",
      dat: conditionData,
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log("addRuleCondition Response:", response.data);

    return response.data;
  } catch (error) {
    console.error("addRuleCondition API Error:", error);
    throw error;
  }
};

// Edit an existing condition
export const updateRuleCondition = async (conditionData) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoanLimitRuleConditionsEdit",
      dat: conditionData,
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log("updateRuleCondition Response:", response.data);

    return response.data;
  } catch (error) {
    console.error("updateRuleCondition API Error:", error);
    throw error;
  }
};

// Add a new action
export const addRuleAction = async (actionData) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoanLimitRuleActionsAdd",
      dat: actionData,
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log("addRuleAction Response:", response.data);

    return response.data;
  } catch (error) {
    console.error("addRuleAction API Error:", error);
    throw error;
  }
};

// Edit an existing action
export const updateRuleAction = async (actionData) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoanLimitRuleActionsEdit",
      dat: actionData,
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log("updateRuleAction Response:", response.data);

    return response.data;
  } catch (error) {
    console.error("updateRuleAction API Error:", error);
    throw error;
  }
};

export const loansUpdateRequestStatus = async (
  location,
  requestid,
  issued,
) => {
  try {
    const data = JSON.stringify({
      svc: "loans4pay",
      pid: "LoansUpdateRequestStatus",
      dat: {
        location,
        requestid,
        issued
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};